import React, { useState, useEffect } from "react";
import {
    Button,
    ButtonToolbar
  } from 'react-bootstrap';
import { useLocation } from "react-router-dom";
import authHeader from "../services/AuthHeader";
import axios from 'axios';
import AuthService from '../services/AuthService';
import { useHistory } from 'react-router-dom';

const Confirm = () => {
    let history = useHistory();
    const location = useLocation();
    const reloadPage = AuthService.reloadPage();
    const reloadPageAlreadyVoted = AuthService.reloadPageAlreadyVoted();

    if (AuthService.alreadyVoted()) {
      history.push(reloadPageAlreadyVoted);//reloadPageAlreadyVoted
      window.location.reload();
    }

    if(typeof location.state === 'undefined'){
      history.push(reloadPage);
      window.location.reload();
    }
    const studentVoted = location.state.studentVoted;
    const votes = location.state.votes;
    const ballotData = location.state.ballotData;
    const studentInfo = location.state.studentInfo;
    const [showBallot,setShowBallot] = useState(false);

    useEffect(() => {
      axios
        .get(
          process.env.REACT_APP_API_BASE + 'voted/'+ studentInfo.starId,{ headers: authHeader() }
        )
        .then((res) => {
          if (res.data) {
              setShowBallot(false);
              history.push("/");
          } else {
              setShowBallot(true);
          }
        });
    }, []);

  const onSubmit = (e) => {
    e.preventDefault();
  };

  const handleVote = () => {
    axios
      .post(process.env.REACT_APP_API_BASE + 'voteelectionballot/', votes, {
        headers: authHeader(),
      })
      .then((res) => {
        if (localStorage.getItem('studentVoted') === null) {
          localStorage.setItem('studentVoted', studentVoted);
        }

        history.push({
          pathname: '/record',
          state: {
            // location state
            votes: votes,
            ballotData: ballotData,
            studentInfo: studentInfo,
          },
        });
      });
  };

  return (ballotData && showBallot ? (
    <form onSubmit={onSubmit}>
      <h1>{ballotData.electionName}</h1>
      <h2>Please Confirm Your Votes</h2>
      {ballotData.allBallots
        .map((ballot) => {        
            if(ballot.ballotRestrictionTypeId === 1
              || (ballot.ballotRestrictionTypeId === 2 && studentInfo.classLevel === ballot.ballotRestrictionDetail)
              || (parseInt(ballot.ballotRestrictionTypeId) === 3 && studentInfo.classLevel !== 'G' && studentInfo.allColleges.some(college => college.coll === ballot.ballotRestrictionDetail))
              || (ballot.ballotRestrictionTypeId === 4 && studentInfo.residential === ballot.ballotRestrictionDetail)
            ) { 
              let elements = [];
              let curVote = votes.allBallots.filter(x => x.BallotId === ballot.ballotId);
              if (curVote) {
                /*
{candidate.ballotCandidateName} {!ballot.referendum ? ' - ' + (candidate.ballotCandidatePartyName ? candidate.ballotCandidatePartyName : 'Independent') : ''}
                */
                for (let i=0; i < curVote.length; i++) {
                    if (curVote[i].WriteIn) {
                        elements.push(<div>{curVote[i].CandidateName} - Write In</div>);
                    } else {
                        let candidateName = ballot.allCandidates.find(c=> c.ballotCandidateId === curVote[i].BallotCandidateId).ballotCandidateName;
                        if(!ballot.referendum) {
                          let candidatePartyName = ballot.allCandidates.find(c=> c.ballotCandidateId === curVote[i].BallotCandidateId).ballotCandidatePartyName;
                          candidatePartyName = candidatePartyName === '' ? 'Independent' : candidatePartyName;
                          elements.push(<div>{candidateName} - {candidatePartyName}</div>);
                        } else {
                          elements.push(<div>{candidateName}</div>);
                        }
                    }
                }
              } 
              return (
                <React.Fragment key={ballot.ballotId}>
                    <h3 className='ballot-name'>{ballot.ballotName}</h3>
                    { elements.length ? elements : '--Abstained--'}
               </React.Fragment>
              );
          } else return false;
        })
        }
     
      <hr />
      <ButtonToolbar>
      <Button
          bsStyle="primary"
          type='submit'
          onClick={() => history.goBack()}
      >
      Back
      </Button>
      <Button
          className='btn btn-default'
          type='submit'
          onClick={() => handleVote()}
      >
      Submit My Vote
      </Button>
      </ButtonToolbar>
      <hr />
      </form>
    ) : 'Loading...'
  ); 
};
export default Confirm;
